// Lightweight i18n. Italian is primary; English is the selectable second language.
import React, { createContext, useContext, useState, useCallback } from "react";

const DICT = {
  it: {
    "app.tagline": "Regulatory Intelligence. Compliance. Action.",
    "nav.dashboard": "Dashboard", "nav.radar": "Radar Regolatorio", "nav.copilot": "Regulatory Copilot",
    "nav.sito": "Il mio sito", "nav.prodotti": "Prodotti", "nav.clienti": "Clienti",
    "nav.change": "Change Impact", "nav.documents": "Document Intelligence", "nav.tasks": "Action Hub",
    "nav.calendar": "Calendario", "nav.inspection": "Inspection Intelligence", "nav.readiness": "Inspection Readiness",
    "nav.supplier": "Supplier Intelligence", "nav.commitments": "Regulatory Commitments",
    "nav.watchlist": "Watchlist", "nav.reports": "Reports", "nav.kb": "Knowledge Base",
    "nav.sources": "Registro Fonti", "nav.admin": "Admin", "nav.audit": "Audit Trail",
    "common.logout": "Esci", "common.search": "Cerca...", "common.save": "Salva", "common.cancel": "Annulla",
    "common.loading": "Caricamento...", "common.relevance": "Rilevanza", "common.impact": "Impatto",
    "common.applicability": "Applicabilità", "common.comingSoon": "In arrivo", "common.viewAll": "Vedi tutto",
    "sec.today": "La tua situazione regolatoria oggi", "sec.priorities": "Priorità suggerite dalla AI",
    "login.title": "Accedi alla piattaforma", "login.email": "Email", "login.password": "Password",
    "login.google": "Continua con Google", "login.submit": "Accedi",
  },
  en: {
    "app.tagline": "Regulatory Intelligence. Compliance. Action.",
    "nav.dashboard": "Dashboard", "nav.radar": "Regulatory Radar", "nav.copilot": "Regulatory Copilot",
    "nav.sito": "My Site", "nav.prodotti": "Products", "nav.clienti": "Clients",
    "nav.change": "Change Impact", "nav.documents": "Document Intelligence", "nav.tasks": "Action Hub",
    "nav.calendar": "Calendar", "nav.inspection": "Inspection Intelligence", "nav.readiness": "Inspection Readiness",
    "nav.supplier": "Supplier Intelligence", "nav.commitments": "Regulatory Commitments",
    "nav.watchlist": "Watchlist", "nav.reports": "Reports", "nav.kb": "Knowledge Base",
    "nav.sources": "Source Registry", "nav.admin": "Admin", "nav.audit": "Audit Trail",
    "common.logout": "Logout", "common.search": "Search...", "common.save": "Save", "common.cancel": "Cancel",
    "common.loading": "Loading...", "common.relevance": "Relevance", "common.impact": "Impact",
    "common.applicability": "Applicability", "common.comingSoon": "Coming soon", "common.viewAll": "View all",
    "sec.today": "Your regulatory situation today", "sec.priorities": "AI-suggested priorities",
    "login.title": "Access the platform", "login.email": "Email", "login.password": "Password",
    "login.google": "Continue with Google", "login.submit": "Sign in",
  },
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("ri_lang") || "it");
  const setLanguage = useCallback((l) => { localStorage.setItem("ri_lang", l); setLang(l); }, []);
  const t = useCallback((key) => (DICT[lang] && DICT[lang][key]) || DICT.it[key] || key, [lang]);
  return <I18nCtx.Provider value={{ lang, setLanguage, t }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
